import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { forwardRef as T } from "react";
import { BaseIcon as d } from "../BaseIcon/index.js";
import { TooltipTrigger as j, Tooltip as x } from "../Tooltip/index.js";
import '../../assets/index3.css';const I = "_infoTooltip_1jb68_1", _ = {
  infoTooltip: I
}, w = T(
  ({ children: i, placement: t, size: r = "md", id: n, m: p, mt: e, mr: f, mb: l, ml: m, ...s }, a) => /* @__PURE__ */ c(j, { delay: "immediate", children: [
    /* @__PURE__ */ o(
      d,
      {
        size: r,
        id: n,
        m: p,
        mt: e,
        mr: f,
        mb: l,
        ml: m,
        ref: a,
        className: _.infoTooltip,
        icon: "info",
        description: s["aria-label"],
        "data-component": "InfoTooltip"
      }
    ),
    /* @__PURE__ */ o(x, { placement: t, children: i })
  ] })
);
export {
  w as InfoTooltip
};
//# sourceMappingURL=index.js.map
